import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { colors, fonts, spacing } from '../../constants';

/**
 * PageHeader Component
 * Page header with description and refresh button
 */
const PageHeader = ({ onRefresh, loading }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: spacing.md }}>
      <Typography variant="body1" sx={{ color: colors.textSecondary, fontSize: fonts.fontSizeMd, mt: 0 }}>
        Monitor SLA performance and compliance metrics.
      </Typography>
      <Tooltip title="Refresh data">
        <IconButton
          onClick={onRefresh}
          disabled={loading}
          sx={{
            color: colors.primary,
            '&:hover': {
              backgroundColor: colors.backgroundSoft,
            },
          }}
        >
          <RefreshIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default PageHeader;
